import { render, staticRenderFns } from "./CategoryDialogComponent.vue?vue&type=template&id=4e6ff4f8&scoped=true"
import script from "./CategoryDialogComponent.js?vue&type=script&lang=js&external"
export * from "./CategoryDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./CategoryDialogComponent.vue?vue&type=style&index=0&id=4e6ff4f8&prod&scoped=true&lang=scss"
import style1 from "./CategoryDialogComponent.vue?vue&type=style&index=1&id=4e6ff4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ff4f8",
  null
  
)

export default component.exports